// test21
(21 && 0);
